<template>
  <nav>
    <div class="nav-inner">
      <ul class="nav-items">
        <li class="logo">
          <router-link to="/">
            J&C's
          </router-link>
        </li>
        <li>
          <router-link to="/about">About</router-link>
        </li>
        <li>
          <a href="https://jcslobsterpot.touchtakeaway.net" target="_blank">Order</a>
        </li>
        <li>
          <router-link to="/book">Book</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 20%;
  background-image: url("../assets/img/nav-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  background:#fff;
  border: unset;
  border-right: var(--border);
  animation: fadeInBottom 0.5s ease-out 0s both;
  z-index: 9;
  @media (max-width: 1024px) {
    position: relative;
    width: 100%;
    height: 100px;
    animation: fadeInTop 0.5s ease-out 0s both;
  }
  .nav-inner {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 20px 20%;
    text-align: left;
    @media (max-width: 1024px) {
      flex-direction: row;
      align-items: center;
      padding: 10px;
    }
    ul.nav-items {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: center;
      padding: 0 40px;
      @media (max-width: 1024px) {
        flex-direction: row;
        width: auto;
        align-items: center;
        height: 100%;
        padding: 0;
      }
      li {
        position: relative;
        margin: 0 0 50px 0;
        text-align: left;
        @for $i from 1 through 4 {
          &:nth-child(#{$i}) {
            animation: fadeInLeft 0.75s #{$i * 0.25}s ease 1 both;
          }
        }
        @media (max-width: 1024px) {
          margin: 0 25px 0 0;
          @for $i from 1 through 4 {
            &:nth-child(#{$i}) {
              animation: fadeInTop 0.75s #{$i * 0.25}s ease 1 both;
            }
          }
        }
        &:last-child {
          @media (max-width: 1024px) {
            margin: 0;
          }
        }
        a {
          position: relative;
          display: inline-block;
          width: auto;
          font-size: 26px;
          font-weight: 500;
          opacity: 0.75;
          color: var(--prim-c);
          @media (max-width: 1024px) {
            font-size: 18px;
          }
          &:after {
            content: "";
            position: absolute;
            width: 0%;
            height: 4px;
            bottom: -6px;
            left: 0;
            background-color: var(--prim-c);
            transition: 0.25s ease-out;
          }
          &:hover:after {
            width: 100%;
            opacity: 1;
          }
          &:hover {
            opacity: 1;
          }
        }
      }
      .logo {
        a {
          font-weight:900;
          font-size:42px;
          img {
            max-height: 150px;
            @media (max-width: 1024px) {
              max-height: 60px;
            }
          }
          &:hover:after {
            opacity: 0;
            width: 0;
          }
        }
      }
    }
  }
}
</style>
